module.exports = __webpack_public_path__ + "static/media/红绿波段@2x.4331886b.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_172/images/红绿波段@2x.png
// module id = 1569
// module chunks = 0